export const GET_NETWORK_SETTINGS_REQUEST = 'GET_NETWORK_SETTINGS_REQUEST';
export const GET_NETWORK_SETTINGS_SUCCESS = 'GET_NETWORK_SETTINGS_SUCCESS';
export const GET_NETWORK_SETTINGS_FAILURE = 'GET_NETWORK_SETTINGS_FAILURE';
export const PATCH_NETWORK_SETTINGS_REQUEST = 'PATCH_NETWORK_SETTINGS_REQUEST';
export const PATCH_NETWORK_SETTINGS_SUCCESS = 'PATCH_NETWORK_SETTINGS_SUCCESS';
export const PATCH_NETWORK_SETTINGS_FAILURE = 'PATCH_NETWORK_SETTINGS_FAILURE';
